import React from 'react'
import s from './FiltersBar.module.scss'

const FiltersBar = ({ chips = [], onRemoveChip, onClearAll }) => {
	const hasChips = chips.length > 0
	if (!hasChips) return null

	return (
		<div className={s.wrap}>
			<div className={s.chips}>
				{chips.map(chip => (
					<button
						key={chip.id}
						type="button"
						className={`${s.chip} ${s.chipExtra} ${s.chipActive}`.trim()}
						onClick={() => onRemoveChip?.(chip)}
					>
						<span className={s.chipText}>{chip.label}</span>
						<span
							className={s.chipRemove}
							role="button"
							tabIndex={0}
							onClick={e => {
								e.stopPropagation()
								onRemoveChip?.(chip)
							}}
							onKeyDown={e => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault()
									e.stopPropagation()
									onRemoveChip?.(chip)
								}
							}}
							aria-label={`Remove ${chip.label}`}
						>
							×
						</span>
					</button>
				))}
			</div>

			<button type="button" className={s.clearAll} onClick={onClearAll}>
				Clear all
			</button>
		</div>
	)
}

export default FiltersBar
